import { apiResolver } from '@nile/graphql';

/**
 * This method gives the query and client using which the API calls will be made
 * after selecting the attribute
 * @param {object} item
 * @param {String} operator
 */

function onQuerySearch(params) {
  if (!params) return {};
  const query = apiResolver.Common?.[params]?.api;
  const client = apiResolver.Common?.[params]?.client;
  const variables = apiResolver.Common?.[params]?.variables || null;
  return {
    client: client,
    query: query,
    variables: variables
  };
}

export { onQuerySearch };
